import React from 'react';
import { PageTemplateBox } from './PageTemplateBox';
import { Box, Button, SimpleGrid } from '@chakra-ui/react';
import { StorageService } from '../services/StorageService';
import { NewPageDialog } from '../dashboard/NewPageDialog';

export const AdminPageTemplates = (props: {
  buildinTemplateIds: string[];
}) => {

  const [isNewPageDialogOpen, setIsNewExportDialogOpen] = React.useState(false);
  const [templateIds, setTemplateIds] = React.useState<string[]>(props.buildinTemplateIds);

  const loadExistingTemplates = async () => {
    StorageService.getTemplateList().then((loadedNames: string[] | undefined) => {
      if (loadedNames) {
        setTemplateIds([...props.buildinTemplateIds, ...loadedNames]);
      } else {
        return [];
      }
    });
  }

  React.useEffect(() => {
    loadExistingTemplates()
  }, []);

  const onDeletePage = async (templateId: string) => {
    await StorageService.deleteTemplateFile(templateId);
    setTemplateIds(prev => prev.filter(id => id !== templateId));
  }

  const onRenamePage = async (oldId: string, newId: string) => {
    await StorageService.renameTemplateFile(oldId, newId);
    setTemplateIds(prev => prev.map(id => (id === oldId ? newId : id)));
  }

  return (
    <>
      <Box mb={4}>
        <Button variant='solid' onClick={() => setIsNewExportDialogOpen(true)}>Create Custom Page...</Button>
      </Box>
     <SimpleGrid columns={2} spacing={6}>
        {templateIds.map(templateId => (
          <PageTemplateBox
            key={templateId}
            templateId={templateId}
            onDeletePage={onDeletePage}
            onRenamePage={onRenamePage}
          />
        ))}
      </SimpleGrid>
      {isNewPageDialogOpen && <NewPageDialog onClose={() => setIsNewExportDialogOpen(false)} />}
    </>

  );
}